import React from 'react'
import type { ReactNode } from 'react'
import { ModalBox } from '../../partials/ModalBox'
import { useModalContext } from '../../providers/ModalProvider'
import { FeeCheckbox } from './components/FeeCheckbox'
import { SellingPriceInput } from './components/SellingPriceInput'
import * as S from './styled'

export type RootProps = {
  content: ReactNode
  includeFeesValue: boolean
  suggestions: string[]
  title: string
  onToggleIncludeFeesValue: () => void
}

const Root = ({
  title,
  content,
  includeFeesValue,
  suggestions,
  onToggleIncludeFeesValue,
}: RootProps) => {
  const { close } = useModalContext()

  const renderSuggestions = () => {
    if (!suggestions.length) {
      return null
    }

    return (
      <S.Suggestions>
        {suggestions.map((suggestion, index) => (
          <div key={index}>{suggestion}</div>
        ))}
      </S.Suggestions>
    )
  }

  return (
    <ModalBox size="small" title={title} onClose={close}>
      {renderSuggestions()}
      {content}
      <div>
        <FeeCheckbox value={includeFeesValue} onValueChange={onToggleIncludeFeesValue} />
      </div>
    </ModalBox>
  )
}

const PriceInput = ({
  priceValue,
  onPriceChange,
  onSellingPriceBlur,
}: {
  priceValue: string
  onSellingPriceBlur: () => void
  onPriceChange: (value: string) => void
}) => {
  return (
    <S.SellingPriceInputWrapper>
      <SellingPriceInput
        value={priceValue}
        onBlur={onSellingPriceBlur}
        onValueChange={onPriceChange}
      />
    </S.SellingPriceInputWrapper>
  )
}

export { Root, PriceInput }
